// src/components/StatsDashboard.jsx
import { useEffect, useState } from "react";
import {
    db,
    collection,
    onSnapshot,
    query,
} from "./firebase"; // Ajusta la ruta
import { Bar, Line } from "react-chartjs-2"; // Ejemplo de charts
import { getStartOfDay, getStartOfMonth, getLast7Dates, getLast6Months } from "./utils/dateHelpers"; // Funciones para filtrar (opcional)

import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    LineElement,
    PointElement,
    Title,
    Tooltip,
    Legend,
} from "chart.js";

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    LineElement,
    PointElement,
    Title,
    Tooltip,
    Legend
);


export default function StatsDashboard() {
    // Estados para indicadores
    const [dailyConversations, setDailyConversations] = useState(0);
    const [dailyNewUsers, setDailyNewUsers] = useState(0);
    const [monthlyConversations, setMonthlyConversations] = useState(0);
    const [monthlyNewUsers, setMonthlyNewUsers] = useState(0);

    // Datos para “consultas frecuentes” (top queries)
    const [frequentQueries, setFrequentQueries] = useState([]);
    // Datos para “preguntas no entrenadas”
    const [untrainedQuestions, setUntrainedQuestions] = useState([]);

    // (Opcional) Para gráficos por día/mes
    const [dailyConvosChartData, setDailyConvosChartData] = useState(null);
    const [monthlyConvosChartData, setMonthlyConvosChartData] = useState(null);

    // Nuevos estados para consultas frecuentes y preguntas no entrenadas
    const [frequentQueriesData, setFrequentQueriesData] = useState([]);
    const [untrainedQueriesData, setUntrainedQueriesData] = useState([]);

    useEffect(() => {
        // Suscribirse a "activeUsers"
        const qActiveUsers = query(collection(db, "activeUsersDemasled"));
        const unsubscribe = onSnapshot(qActiveUsers, (snapshot) => {
            // Extraemos todos los campos, incluimos 'id' si hace falta
            const data = snapshot.docs.map((doc) => ({
                id: doc.id,
                ...doc.data(),
            }));
            // Procesamos la data, asumiendo que cada doc trae su array historyChat
            processConversationsData(data);
            processUsersData(data);
            // processConversationsDataCharts(data);
        });

        return () => {
            unsubscribe();
        };
    }, []);


    // Suscripción a "frequentQueries"
    useEffect(() => {
        const qFrequent = query(collection(db, "frequentQueries"));
        const unsubscribeFrequent = onSnapshot(qFrequent, (snapshot) => {
            const data = snapshot.docs.map((doc) => ({
                id: doc.id,
                ...doc.data(),
            }));
            setFrequentQueriesData(data);
        });
        return () => {
            unsubscribeFrequent();
        };
    }, []);

    // Suscripción a "untrainedQueries"
    useEffect(() => {
        const qUntrained = query(collection(db, "untrainedQueries"));
        const unsubscribeUntrained = onSnapshot(qUntrained, (snapshot) => {
            const data = snapshot.docs.map((doc) => ({
                id: doc.id,
                ...doc.data(),
            }));
            setUntrainedQueriesData(data);
        });
        return () => {
            unsubscribeUntrained();
        };
    }, []);


    function processConversationsData(activeUsersDocs) {
        // Aquí, 'activeUsersDocs' es un arreglo con cada documento de la colección "activeUsers"

        const startOfToday = getStartOfDay(); // tu función util para filtrar por día
        const startOfMonth = getStartOfMonth(); // tu función util para filtrar por día

        // Cantidad de conversaciones actualizadas hoy
        const updatedToday = activeUsersDocs.filter(doc => doc.lastUpdate >= startOfToday).length
        // console.log("Conversaciones con update hoy:", updatedToday);

        const updatedMonth = activeUsersDocs.filter(doc => doc.lastUpdate >= startOfMonth).length;
        // console.log("Conversaciones con update mensual:", updatedToday);


        setDailyConversations(updatedToday);
        setMonthlyConversations(updatedMonth);
    }


    function processUsersData(activeUsersDocs) {
        // Filtramos usuarios creados hoy
        const startOfToday = getStartOfDay(); // tu función util para filtrar por día
        const startOfMonth = getStartOfMonth(); // tu función util para filtrar por día

        const createdToday = activeUsersDocs.filter(doc => doc.createdAt >= startOfToday).length
        const createdMonth = activeUsersDocs.filter(doc => doc.createdAt >= startOfMonth).length

        setDailyNewUsers(createdToday);
        setMonthlyNewUsers(createdMonth);
    }


    // function processConversationsDataCharts(activeUsersDocs) {
    //     // Datos para gráficos diarios: usamos lastUpdate en lugar de createdAt
    //     const dailyCountsMap = {};
    //     activeUsersDocs.forEach((doc) => {
    //         const date = new Date(doc.lastUpdate);
    //         const dateKey = date.toISOString().split("T")[0]; // YYYY-MM-DD
    //         dailyCountsMap[dateKey] = (dailyCountsMap[dateKey] || 0) + 1;
    //     });
    //     const last7Dates = getLast7Dates();
    //     const dailyLabels = [];
    //     const dailyCounts = [];
    //     last7Dates.forEach((d) => {
    //         dailyLabels.push(d);
    //         dailyCounts.push(dailyCountsMap[d] || 0);
    //     });
    //     const dailyData = {
    //         labels: dailyLabels,
    //         datasets: [
    //             {
    //                 label: "Conversaciones por día",
    //                 data: dailyCounts,
    //             },
    //         ],
    //     };
    //     setDailyConvosChartData(dailyData);

    //     // Datos para gráficos mensuales: usamos lastUpdate
    //     const monthlyCountsMap = {};
    //     activeUsersDocs.forEach((doc) => {
    //         const date = new Date(doc.lastUpdate);
    //         const monthKey = `${date.getFullYear()}-${(date.getMonth() + 1)
    //             .toString()
    //             .padStart(2, "0")}`;
    //         monthlyCountsMap[monthKey] = (monthlyCountsMap[monthKey] || 0) + 1;
    //     });
    //     const last6Months = getLast6Months();
    //     const monthlyLabels = [];
    //     const monthlyCountsArr = [];
    //     last6Months.forEach((m) => {
    //         monthlyLabels.push(m);
    //         monthlyCountsArr.push(monthlyCountsMap[m] || 0);
    //     });
    //     const monthlyData = {
    //         labels: monthlyLabels,
    //         datasets: [
    //             {
    //                 label: "Conversaciones mensuales",
    //                 data: monthlyCountsArr,
    //             },
    //         ],
    //     };
    //     setMonthlyConvosChartData(monthlyData);
    // }



    // Renderizado
    return (
        <div className="space-y-6">
            {/* Tarjetas de indicadores */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                <IndicatorCard title="Conversaciones hoy" value={dailyConversations} />
                <IndicatorCard title="Nuevos usuarios hoy" value={dailyNewUsers} />
                <IndicatorCard title="Conversaciones mes" value={monthlyConversations} />
                <IndicatorCard title="Nuevos usuarios mes" value={monthlyNewUsers} />
            </div>


            {/* Gráfico diario */}
            {/* {dailyConvosChartData && (
                <div className="bg-base-100 p-4 rounded shadow">
                    <h2 className="text-lg font-bold mb-2">
                        Conversaciones por día (últimos 7 días)
                    </h2>
                    <Bar
                        data={dailyConvosChartData}
                        key="bar-daily"
                        options={{
                            responsive: true,
                            maintainAspectRatio: false,
                        }}
                    />
                </div>
            )} */}

            {/* Gráfico mensual */}
            {/* {monthlyConvosChartData && (
                <div className="bg-base-100 p-4 rounded shadow">
                    <h2 className="text-lg font-bold mb-2">
                        Conversaciones por mes (últimos 6 meses)
                    </h2>
                    <Line
                        data={monthlyConvosChartData}
                        key="line-monthly"
                        options={{
                            responsive: true,
                            maintainAspectRatio: false,
                        }}
                    />
                </div>
            )} */}

            {/* Cuadro de consultas frecuentes */}
            {/* <div className="bg-base-100 p-4 rounded shadow">
                <h2 className="text-lg font-bold mb-2">
                    Consultas frecuentes
                </h2>
                {frequentQueriesData.length > 0 ? (
                    <table className="table w-full">
                        <thead>
                            <tr>
                                <th>Consulta</th>
                                <th>Persona</th>
                                <th>Fecha</th>
                            </tr>
                        </thead>
                        <tbody>
                            {frequentQueriesData.map((doc) => (
                                <tr key={doc.id}>
                                    <td>{doc.query}</td>
                                    <td>{doc.personName}</td>
                                    <td>{new Date(doc.createdAt).toLocaleString()}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                ) : (
                    <p>No hay datos</p>
                )}
            </div> */}


            {/* Cuadro de preguntas no entrenadas */}
            {/* <div className="bg-base-100 p-4 rounded shadow">
                <h2 className="text-lg font-bold mb-2">
                    Preguntas no entrenadas
                </h2>
                {untrainedQueriesData.length > 0 ? (
                    <table className="table w-full">
                        <thead>
                            <tr>
                                <th>Mensaje</th>
                                <th>Persona</th>
                                <th>Fecha</th>
                            </tr>
                        </thead>
                        <tbody>
                            {[...untrainedQueriesData]
                                // Orden descendente (más reciente primero)
                                .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
                                .map((doc) => (
                                    <tr key={doc.id}>
                                        <td>{doc.query}</td>
                                        <td>{doc.personName}</td>
                                        <td>{new Date(doc.createdAt).toLocaleString()}</td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>
                ) : (
                    <p>No se encontraron datos</p>
                )}
            </div> */}
        </div>
    );
}

// Ejemplo de una tarjeta individual para indicadores
function IndicatorCard({ title, value }) {
    return (
        <div className="stats shadow bg-base-100">
            <div className="stat">
                <div className="stat-title">{title}</div>
                <div className="stat-value">{value}</div>
            </div>
        </div>
    );
}
